import { render, staticRenderFns } from "./toolsDatabase.vue?vue&type=template&id=ac6d4ad8&"
import script from "./toolsDatabase.vue?vue&type=script&lang=js&"
export * from "./toolsDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports